/*
 * tc-growthbook.js — GrowthBook SDK init + exposure tracking.
 *
 * Loads after growthbook-sdk.js (vendored bundle, window.growthbook) and the
 * tc-tracking-config snippet (window.TC_TRACKING). Exposes window.TC_GB.
 *
 * HOW EXPOSURES WORK (the one rule every experiment must follow):
 * nothing fires at init — init only fetches feature rules. The exposure fires
 * when experiment-gated code EVALUATES a flag, e.g.
 *
 *     if (window.TC_GB && TC_GB.isOn('pdp-autoplay-video')) { …variant… }
 *
 * at the actual render-decision point. That evaluation assigns the variation
 * and synchronously invokes trackingCallback below. Evaluate at the real
 * exposure point, BEFORE any variation-dependent branching, and never
 * speculatively (a global evaluation dilutes effects; a post-branch one causes
 * sample-ratio mismatch). Deduped per page load by the SDK.
 */
(function () {
  var cfg = window.TC_TRACKING;
  if (!cfg || !cfg.enabled) return;
  if (!window.growthbook || !window.growthbook.GrowthBook) return;

  var gb = new window.growthbook.GrowthBook({
    apiHost: cfg.gbApiHost,
    clientKey: cfg.gbClientKey,
    attributes: {
      // Same value under both names: experiments can hash on `id` (SDK
      // default) or `anonymous_id` (the warehouse identifier type) and both
      // resolve to the tc_aid cookie — no hash/identifier mismatch possible.
      id: cfg.anonymousId,
      anonymous_id: cfg.anonymousId,
      url: location.href,
      path: location.pathname,
      environment: cfg.environment
    },
    trackingCallback: function (experiment, result) {
      cfg.send({
        type: 'exposure',
        anonymous_id: cfg.anonymousId,
        timestamp: new Date().toISOString(),
        experiment_key: experiment.key,
        variation_key: String(result.key),
        environment: cfg.environment,
        source: 'shopify_theme',
        properties: { url: location.href }
      });
    }
  });

  window.TC_GB = gb;

  // streaming:false — no SSE connection; features come from one fetch (and the
  // SDK's localStorage cache on repeat views, which also curbs flicker).
  gb.init({ streaming: false })
    .then(function () {
      // A/A launch-validation experiment (both variations identical, no
      // visual change). Evaluating here — globally, on every pageview — is
      // the ONE sanctioned exception to "evaluate at the render point":
      // an A/A test has no render point, and every-page exposure volume is
      // the point (SRM calibration, dashboard bring-up). No-ops harmlessly
      // if the flag doesn't exist. Remove when the A/A test concludes.
      gb.isOn('aa-launch-validation');

      // Readiness signal for experiment-gated code elsewhere in the theme:
      // feature rules are loaded, evaluations are now meaningful. Consumers
      // must check TC_GB_READY before subscribing (the event may have fired
      // before their script ran). If init fails, neither fires — gated code
      // stays on control, which is the correct fallback.
      window.TC_GB_READY = true;
      document.dispatchEvent(new Event('tc:growthbook-ready'));
    })
    .catch(function () {});
})();
